import { getRandomInt } from '../../utils/functional';

export const BUILDING_PROGRESS_TEXTS = ['ход строительства', 'фото со стройки', 'фото'];

export const getBuildingProgressText = (): string => {
  const textIndex = getRandomInt(0, BUILDING_PROGRESS_TEXTS.length - 1);

  return BUILDING_PROGRESS_TEXTS[textIndex];
};
